import React from "react";
import {Router, Redirect, Switch} from "react-router-dom";
import HubList from "../hub-list/HubList";
import History from '../common/History'
import PrivateRoute from "../auth/PrivateRoute";
import {useAuth0} from "../auth/SSO";
import Loading from "../common/Loading";
import NavBar from "../navigation-bar/NavBar";
import queryString from 'query-string';
import HubTelemetryExport from "../telemetry-export/HubTelemetryExport";
import Snackbar from "../common/Snackbar";
import HubDashboard from "../hub-dashboard/HubDashboard";

function App() {
    const redirectToHub = (hubId) => {
        History.push(`/hubs/${hubId}`);
    };

    const {loading} = useAuth0();

    if (loading) {
        return <Loading/>;
    }

    return (
        <Router history={History}>
            <div>
                <NavBar/>
                <Snackbar/>
                <Switch>
                    <PrivateRoute path="/" exact component={() => (<Redirect exact to="/hubs"/>)}/>

                    <PrivateRoute path="/hubs" exact
                                  component={() => (
                                      <HubList selectHub={redirectToHub}/>
                                  )}/>

                    <PrivateRoute path="/hubs/:hubId" exact component={(props) => {
                        const {hubId} = props.match.params;

                        return (
                            <HubDashboard hubId={hubId}/>
                        );
                    }}/>

                    <PrivateRoute path="/hubs/:hubId/telemetry/export" exact component={(props) => {
                        const {hubId} = props.match.params;
                        const {from, to} = queryString.parse(props.location.search);

                        return (
                            <HubTelemetryExport hubId={hubId} from={from} to={to}/>
                        );
                    }}/>
                </Switch>
            </div>
        </Router>
    );
}

export default App;